import { useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useSiteContent } from "@/lib/siteContent";

const CATS = [
  { key: "all", label: "Todos" },
  { key: "corporativo", label: "Corporativo" },
  { key: "esportivo", label: "Esportivo" },
  { key: "camisetas", label: "Camisetas" },
  { key: "polos", label: "Polos" },
  { key: "moletons", label: "Moletons" },
  { key: "jaquetas", label: "Jaquetas" },
  { key: "personalizados", label: "Personalizados" },
];

export default function PublicProdutos() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("all");
  const { content } = useSiteContent();
  const p = content.produtos_page || {};

  useEffect(() => { api.get("/products").then(({data}) => setItems(data)); }, []);
  const filtered = (cat === "all" ? items : items.filter((p) => p.category === cat)).filter((p) => p.visible_on_site !== false);
  const brl = (v) => "R$ " + (Number(v) || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
      <div className="mb-8">
        <div className="text-xs font-mono uppercase tracking-widest text-[#0CDBF2] mb-3">{p.kicker || "Catálogo"}</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">{p.title || "Nossos produtos"}</h1>
        <p className="text-slate-400 mt-3 max-w-2xl">{p.description}</p>
      </div>

      <div className="flex gap-2 mb-8 overflow-x-auto no-scrollbar -mx-4 px-4 sm:mx-0 sm:px-0 sm:flex-wrap">
        {CATS.map((c) => (
          <button key={c.key} onClick={() => setCat(c.key)} data-testid={`filter-${c.key}`}
            className={`shrink-0 whitespace-nowrap px-5 py-2.5 rounded-full text-sm border transition-colors ${cat===c.key ? "bg-[#0CDBF2] text-[#07090E] border-[#0CDBF2] font-semibold" : "border-slate-700 text-slate-300 hover:border-[#0CDBF2]/50"}`}>
            {c.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {filtered.map((p) => (
          <div key={p.id} data-testid={`product-card-${p.id}`}
            className="rounded-xl overflow-hidden border border-slate-800 bg-[#0B0F17] hover:border-[#0CDBF2]/50 transition-colors flex flex-col">
            <div className="aspect-[4/3] overflow-hidden bg-slate-900">
              {p.image && <img src={mediaUrl(p.image)} alt={p.name} className="w-full h-full object-cover" />}
            </div>
            <div className="p-5 flex-1 flex flex-col">
              <div className="text-xs text-[#0CDBF2] font-mono uppercase tracking-widest mb-1">{p.category}</div>
              <div className="font-heading text-lg font-semibold">{p.name}</div>
              <p className="text-sm text-slate-400 mt-2 line-clamp-3 flex-1">{p.description}</p>
              {p.show_price && p.price != null && Number(p.price) > 0 && (
                <div className="text-sm text-[#0CDBF2] font-mono mt-2" data-testid={`product-price-${p.id}`}>{brl(p.price)}</div>
              )}
              <div className="flex flex-wrap gap-1 mt-3">
                {p.techniques?.map((t) => <Badge key={t} variant="outline" className="border-slate-700 text-slate-300 text-[10px]">{t}</Badge>)}
              </div>
              <div className="text-xs text-slate-500 mt-3">Mín. {p.min_quantity} peças · {p.fabrics?.join(", ")}</div>
              <Link to={`/orcamento?produto=${encodeURIComponent(p.name)}`} className="mt-4" data-testid={`product-quote-${p.id}`}>
                <Button className="w-full bg-[#0CDBF2] hover:bg-[#0ABED4] text-[#07090E] font-semibold">Solicitar orçamento</Button>
              </Link>
            </div>
          </div>
        ))}
        {filtered.length === 0 && <div className="col-span-full text-center text-slate-500 py-16">Nenhum produto nessa categoria.</div>}
      </div>
    </div>
  );
}
